export const MESES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

export const mesCapital = (m: number) => {
  const n = MESES[m - 1] ?? '';
  return n.charAt(0).toUpperCase() + n.slice(1);
};

const NOMBRES_TIPO: Record<string, { singular: string; plural: string }> = {
  DECRETO: { singular: 'Decreto', plural: 'Decretos' },
  ORDENANZA: { singular: 'Ordenanza', plural: 'Ordenanzas' },
  RESOLUCION: { singular: 'Resolución', plural: 'Resoluciones' },
  'DECRETO-HCD': { singular: 'Decreto HCD', plural: 'Decretos HCD' },
  'RESOLUCION-HCD': { singular: 'Resolución HCD', plural: 'Resoluciones HCD' },
  COMUNICACION: { singular: 'Comunicación HCD', plural: 'Comunicaciones HCD' },
  DECLARACION: { singular: 'Declaración HCD', plural: 'Declaraciones HCD' },
  'RESOLUCION INTERNA': { singular: 'Resolución interna', plural: 'Resoluciones internas' },
  DESPACHO: { singular: 'Despacho', plural: 'Despachos' },
};

function capitalizar(s: string) {
  return s
    .toLowerCase()
    .replace(/-/g, ' ')
    .replace(/(^|\s)\p{L}/gu, (c) => c.toUpperCase())
    .replace(/\bHcd\b/g, 'HCD');
}

export const nombreTipo = (t: string) => NOMBRES_TIPO[t]?.singular ?? capitalizar(t);
export const nombreTipoPlural = (t: string) => NOMBRES_TIPO[t]?.plural ?? capitalizar(t);

/** Familia de color por tipo de norma. */
export function familiaTipo(t: string): 'decreto' | 'ordenanza' | 'resolucion' | 'hcd' | 'otro' {
  if (t.includes('HCD') || t === 'COMUNICACION' || t === 'DECLARACION') return 'hcd';
  if (t.startsWith('DECRETO')) return 'decreto';
  if (t.startsWith('ORDENANZA')) return 'ordenanza';
  if (t.startsWith('RESOLUCION')) return 'resolucion';
  return 'otro';
}

const nf = new Intl.NumberFormat('es-AR');
export const numero = (n: number) => nf.format(n);

/** "Decreto N.º 1.234/2026" */
export const cita = (tipo: string, num: number, anio: number) =>
  `${nombreTipo(tipo)} N.º ${nf.format(num)}/${anio}`;

export function fechaLarga(iso: string | null): string {
  if (!iso) return 'Sin fecha';
  const [a, m, d] = iso.split('-').map(Number);
  if (!a || !m || !d) return iso;
  return `${d} de ${MESES[m - 1]} de ${a}`;
}

export function fechaCorta(iso: string | null): string {
  if (!iso) return '—';
  const [a, m, d] = iso.split('-');
  return `${d}/${m}/${a}`;
}

export function tamanio(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} MB`;
}

const VARIANTES: Record<string, string> = {
  a: 'aáàäâ',
  e: 'eéèëê',
  i: 'iíìïî',
  o: 'oóòöô',
  u: 'uúùüû',
  n: 'nñ',
  c: 'cç',
};

/** Regex que encuentra las palabras buscadas ignorando mayúsculas y acentos. */
export function regexResaltado(q: string | undefined, exacto: boolean | undefined): RegExp | null {
  const t = q?.trim();
  if (!t) return null;
  const terminos = (exacto ? [t] : t.split(/\s+/)).filter((p) => p.length >= 2);
  if (!terminos.length) return null;
  const patron = terminos
    .map((p) =>
      [...p.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()]
        .map((ch) => {
          const v = VARIANTES[ch];
          return v ? `[${v}]` : ch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        })
        .join(''),
    )
    .join('|');
  return new RegExp(`(${patron})`, 'giu');
}
